import { supabase } from '../supabaseClient'
import { filasSync, type EstadoGuardado } from './sync-estados'

const TODOS_LOS_ITEMS_PUESTOS = ['GT-02']

interface JobPositionForCompliance {
  id: string
  numero_trabajadores: number | null
  actividades_realizadas: string | null
  horas_actividad_diarias: number | null
  recursos_utilizados: string | null
  materiales_agentes: string | null
}

export async function syncJobPositionsCompliance(companyId: string): Promise<void> {
  if (!companyId) return

  const { data: positions } = await supabase
    .from('job_positions')
    .select('id, numero_trabajadores, actividades_realizadas, horas_actividad_diarias, recursos_utilizados, materiales_agentes')
    .eq('company_id', companyId)

  const positionList = (positions ?? []) as JobPositionForCompliance[]

  let gt02Cumple = false

  if (positionList.length > 0) {
    gt02Cumple = positionList.every(p =>
      p.numero_trabajadores != null &&
      p.horas_actividad_diarias != null &&
      !!p.actividades_realizadas && p.actividades_realizadas.trim() !== '' &&
      !!p.recursos_utilizados && p.recursos_utilizados.trim() !== '' &&
      !!p.materiales_agentes && p.materiales_agentes.trim() !== ''
    )
  }

  const cumpleActual: string[] = []
  if (gt02Cumple) cumpleActual.push('GT-02')

  const { data: existing } = await supabase
    .from('checklist_item_estados')
    .select('item_id, estado, auto_source')
    .eq('company_id', companyId)
    .in('item_id', TODOS_LOS_ITEMS_PUESTOS)

  // Bloque 6, D: manda el módulo (sync-estados.ts): Cumple, En proceso si hay datos o Pendiente; nunca pisa un "No aplica".
  const rows = filasSync(companyId, TODOS_LOS_ITEMS_PUESTOS, cumpleActual, positionList.length > 0 ? TODOS_LOS_ITEMS_PUESTOS : [], (existing ?? []) as EstadoGuardado[], 'puestos_trabajo')

  if (rows.length === 0) return

  await supabase.from('checklist_item_estados').upsert(rows, { onConflict: 'company_id,item_id' })
}
